import getLogger from "utils/logger.util.js";
import API_URLS from "constants/apis.url";

import { extractSystemId } from "../utils/utils.js";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";

const { baselineURL } = API_URLS;
const baselineByTime = API_URLS.baselineByTimeURL;
const isAdminAPI = false;
const Logger = getLogger("Baseline.js(api)");

export const getBaselines = () => getRequest(`${baselineURL}`);
export const getBaseline = (BaselineID, BaselineType) => getRequest(`${baselineURL}/${BaselineID}?baseline_type=${BaselineType}`);

export const getBaselinesFromTimestamp = (timeStamp, timeZone) => {
  timeZone = encodeURIComponent(timeZone);
  const encodedUrl = `${baselineByTime}?timestamp=${timeStamp}&timezone=${timeZone}`;
  return getRequest(encodedUrl);
};

export const addBaseline = dataToPost => {
  const systemID = extractSystemId();
  const URL = `${API_URLS.systemsURL}/${systemID}${API_URLS.baselineURL}`;
  return postRequest(URL, dataToPost, true);
};

export const setAsDefaultBaseline = baselineID => {
  const systemID = extractSystemId();
  const URL = `${API_URLS.systemsURL}/${systemID}${API_URLS.baselineURL}/${baselineID}${API_URLS.default}`;
  return putRequest(URL, null, true);
};

export const deleteBaseline = async dataToDelete => {
  try {
    const url = `${baselineURL}/${dataToDelete.BaselineID}`;
    return await deleteRequest(url, isAdminAPI);
  } catch (err) {
    Logger.error("deleteBaseline - Error: ", err);
  }
};

export const getNormalizationTags = async () => {
  try {
    return getRequest(`${API_URLS.tagMapping}`);
  } catch (err) {
    Logger.error("getNormalizationTags - Error: ", err);
  }
};
export const editNormalizationTags = async dataToPut => {
  try {
    const systemID = extractSystemId();
    const URL = `${API_URLS.adminSystemsURL}/${systemID}${API_URLS.tagMapping}`;
    return await putRequest(URL, dataToPut, true);
  } catch (err) {
    Logger.error("editNormalizationTags - Error: ", err);
  }
};
